import { render, staticRenderFns } from "./V4Alamat.vue?vue&type=template&id=257b77b2&"
import script from "./V4Alamat.vue?vue&type=script&lang=js&"
export * from "./V4Alamat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports